import { Flex, Input } from '@huspy/briks-web';
import { Search } from '@huspy/briks-icons';
import { useNavigate } from '@tanstack/react-router';
import { ChangeEvent } from 'react';
import { debounce } from '@shared/utils';
import { useTranslation } from 'react-i18next';
import { ProposalsListRoute } from '@modules/proposals/presentation/routes';

export const ControlPanel = () => {
  const { t } = useTranslation();

  const { q } = ProposalsListRoute.useSearch();

  const navigate = useNavigate({ from: ProposalsListRoute.fullPath });

  const debouncedSearch = debounce((value: string) => {
    navigate({
      search: (prev) => ({
        ...prev,
        ...(value.length > 0 ? { q: value } : { q: undefined }),
      }),
    });
  }, 500);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  return (
    <Flex w='221px'>
      <Input
        placeholder={ t('opportunity.caseList.v2.search') }
        bg='bg-secondary'
        w='221px'
        borderColor='border-secondary'
        backdropFilter='blur(32px);'
        icon={ <Search width={ 24 } height={ 24 } color='#6B7280' /> }
        iconPosition='left'
        defaultValue={ q }
        onChange={ handleSearch }
        spellCheck={ false }
        size='md'
        width='100%'
        css={ { paddingLeft: '12' } }
        data-test='search-client-input'
      />
    </Flex>
  );
};
